var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-setting-modal-component select-none" },
    [
      _c("div", { staticClass: "room-setting-modal" }, [
        _c("div", { staticClass: "room-setting-header" }, [
          _c("div", { staticClass: "room-setting-title-wrapper" }, [
            _c("h5", { staticClass: "room-setting-title" }, [
              _vm._v(_vm._s(_vm.$t("setting.title"))),
            ]),
            _c("div", { staticClass: "room-setting-header-btn-wrapper" }, [
              _c("button", {
                staticClass: "room-setting-header-btn",
                on: { click: _vm.onCancel },
              }),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "room-setting-body" },
          [
            _c("RoomSettingMenu", { on: { changeMenu: _vm.changeMenu } }),
            _c("RoomSettingContent", {
              ref: "content",
              attrs: { "is-selected": _vm.selectedMenu },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "room-setting-footer" }, [
          _c(
            "button",
            {
              staticClass: "room-setting-footer-btn save",
              on: { click: _vm.onSave },
            },
            [_vm._v(_vm._s(_vm.$t("common.save")))]
          ),
          _c(
            "button",
            {
              staticClass: "room-setting-footer-btn cancel",
              on: { click: _vm.onCancel },
            },
            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }